<script>
 import Loading from "./../components/loading.svelte"
 import { getMainDefinition } from "apollo-utilities";
 import { WebSocketLink } from "apollo-link-ws"
 import { split } from "apollo-link"
 import { ApolloClient } from "apollo-client"
 import { HttpLink } from "apollo-link-http"
 import { InMemoryCache } from "apollo-cache-inmemory"
 import { text_area_resize } from "../components/autoresize_textarea"
 import {
   createApolloClient,
   QUESTIONS,
   ADD_QUESTION,
 } from "../components/graphql"
 import { mutation, subscribe, setClient } from "svelte-apollo"
 import { onMount } from "svelte"
 import { getFingerprint } from "../components/fingerprint"

 let question = ""
 const httpLink = new HttpLink({
   uri: "https://cute-ape-95.hasura.app/v1/graphql",
 })
 const wsLink = new WebSocketLink({
   uri: `wss://cute-ape-95.hasura.app/v1/graphql`,
   options: {
     reconnect: true,
   },
 })

 const link = split(
   ({ query }) => {
     const definition = getMainDefinition(query)
     return (
       definition.kind === "OperationDefinition" &&
       definition.operation === "subscription"
     )
   },
   wsLink,
   httpLink
 )
 const client = new ApolloClient({ link, cache: new InMemoryCache() })
 setClient(client)
 let questions = subscribe(QUESTIONS)
 const addQuestion = mutation(ADD_QUESTION)
 async function askQuestion(e) {
   e.preventDefault()
   try {
     const fingerprint = await getFingerprint()
     const askedTime = new Date()
     await addQuestion({variables: { question, fingerprint, askedTime }})
     // clear input
     question = ""
   } catch (error) {
     console.error("erorr", error)
   }
   let now = new Date()
 }
</script>

<style>
 .time {
   color: black;
   font-size: 0.7em;
 }
 .heading {
   display: flex;
   flex-direction: column;
 }
 .question {
   font-weight: 500;
   padding: 0.5em 0;
   color: #00437e;
 }
 .answer {
   font-weight: 300;
   margin: 0;
 }
 textarea {
   padding: 1em;
 }
 button {
   margin-bottom: 1em;
 }
 @media (prefers-color-scheme: dark) {
   textarea {
     background: #333;
     color: white;
     border: none;
     border-radius: 10px;
   }
   button {
     background: #4294dc;
     border: none;
     border-radius: 5px;
   }
   .question {
     color: #4294dc;
   }
   .time {
     color: white;
   }
 }
</style>

<svelte:head>
  <title>Question</title>
</svelte:head>

<h1>Ask alex a question</h1>

<p>
  Enter anything in the box below and click send, questions will be answered
  publicly on this page.
</p>

<form>
  <textarea bind:value={question} use:text_area_resize class="fullwidth" />
  <button on:click={askQuestion}>Send</button>
</form>

{#if $questions.loading}
  <Loading bars={4} />
{:else if $questions.error}
  Error: {$questions.error.message}
{:else}
  {#each $questions.data.questions as { askedTime, answeredTime, question, answer }}
    {#if question}
      <section class="card">
        <div class="heading">
          <span class="time">
            Asked at {askedTime}
            {#if answeredTime}, answered at {answeredTime}{/if}
          </span>
          <span class="question">{question}</span>
        </div>
        {#if answer}
          <p class="answer">
            {@html answer}
          </p>
        {/if}
      </section>
    {/if}
  {/each}
{/if}
